export function handleIfEmpty(data: any) {
  if (!data) {
    return null;
  } else {
    return data;
  }
}

export function isISODate(str: string) {
  if (!/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str)) return false;
  const d = new Date(str);
  return d instanceof Date && !isNaN(d.getTime()) && d.toISOString() === str;
}

export function isValidUrl(string: string) {
  try {
    new URL(string);
    return true;
  } catch (_) {
    return false;
  }
}

/**
 * Calculates the total follower count for a user across all social media platforms.
 * Combines followers from socialMedia object and TikTok data.
 *
 * @param user - User object with socialMedia and tiktokData fields
 * @returns Total follower count across all platforms
 */
export function calculateTotalFollowers(user: {
  socialMedia?: {
    tiktok?: number | null;
    instagram?: number | null;
    youtube?: number | null;
    twitter?: number | null;
    __typename?: string;
  } | null;
  tiktokData?: {
    userInfo?: {
      follower_count?: number | null;
    } | null;
  } | null;
}): number {
  // Get TikTok follower count from tiktokData
  const tiktokFollowers = user.tiktokData?.userInfo?.follower_count || 0;

  // Sum followers from other social media platforms (excluding tiktok and __typename)
  const otherFollowers = user.socialMedia
    ? Object.entries(user.socialMedia)
        .filter(([key]) => key !== "__typename" && key !== "tiktok")
        .reduce((sum, [_, count]) => sum + ((count as number | null) || 0), 0)
    : 0;

  return tiktokFollowers + otherFollowers;
}
